import axios from 'axios';
import each from 'lodash/each';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';

import config from 'config';
import {PaginatableCollection} from 'domains/base/collections';

export default {
    state: {
        orders: new PaginatableCollection(),
        sort: 'created_at',
        sortDirection: 'DESC',
        searchObject: {},
        currentOrder: null,
        eligiblePrintersListForCurrentOrder: null,
    },
    actions: {
        async getOrder({rootState, state, commit}, id) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.jobs.get_job.replace('{jobId}', id)}`);

            commit('updateState', {state, property: 'currentOrder', value: response.data});

            return response;
        },
        async getOrdersAdmin({rootState, state, commit}) {
            let params = [`page=${rootState.route.params.page - 1}`, `sort=${state.sort},${state.sortDirection}`];

            each(state.searchObject, (value, key) => {
                if (!isNull(value) && !isUndefined(value) && value !== '') {
                    params.push(`${key}=${value}${key === 'status' ? '' : '|like'}`);
                }
            });

            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.jobs.search}?${params.join('&')}`);

            commit('setPaginatableCollection', {paginatableCollection: state.orders, data: response.data});

            return response;
        },
        cancelOrder({state}, url) {
            return axios.delete(url || state.currentOrder._links.cancel);
        },
        async assignPrinter({state, dispatch}) {
            let response = await axios.patch(state.currentOrder._links.route_to_printer, {printer_id: state.currentOrder.job.printer_id});

            await dispatch('getOrder', state.currentOrder.job.id);

            return response;
        },
        async getEligiblePrintersListForCurrentOrder({state, commit}) {
            let response = await axios.get(state.currentOrder._links.list_eligible_printers);

            commit('updateState', {
                state,
                property: 'eligiblePrintersListForCurrentOrder',
                value: response.data.printers
            });

            return response;
        },
    },
    mutations: {},
};
